<template>

  <head>

    <meta charset="utf-8" />
    <title>CBHI | Community-Based Health Insurance</title>
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <meta content="Keep your finances and membership up to date" name="description" />
    <meta content="Kelvin Njuguna Ndungu" name="author" />
    <!-- App favicon -->
    <link rel="shortcut icon" href="assets/images/favicon.svg">

    <!-- Bootstrap Css -->
    <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css" />
    <!-- Icons Css -->
    <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css" />

    <!-- Bootstrap select styling -->
    <link rel="stylesheet"
          href="https://cdn.jsdelivr.net/npm/bootstrap-select@1.13.14/dist/css/bootstrap-select.min.css">

    <!-- App Css-->
    <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css" />
    <!-- custom Css-->
    <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css" />



  </head>

  <body data-sidebar="dark">



  <!-- Begin page -->
  <div id="layout-wrapper">



    <!-- ========== Left Sidebar Start ========== -->
    <NavigationBar/>
    <!-- Left Sidebar End -->



    <!-- ============================================================== -->
    <!-- Start right Content here -->
    <!-- ============================================================== -->
    <div class="main-content">

      <div class="page-content">
        <div class="container-fluid">

          <!-- start page title -->
          <div class="row ">
            <div class="col-12">
              <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                <h4 class="mb-sm-0 font-size-18">Flagged Premium Deposits</h4>

                <div class="page-title-right">
                  <ol class="breadcrumb m-0">
                    <li class="breadcrumb-item"><a href="javascript: void(0);">Flagged Deposits</a>
                    </li>

                  </ol>
                </div>

              </div>
            </div>
          </div>

          <!-- Member Statistics Dashboard -->
          <div class="row d-none">
            <!-- Total Members -->
            <div class="col-lg-2 col-md-4">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="d-flex flex-wrap">
                    <div class="me-3">
                      <p class="text-muted mb-2">Total Members</p>
                      <h5 class="mb-0">1,238</h5>
                    </div>
                    <div class="avatar-sm ms-auto">
                      <div class="avatar-title bg-primary rounded-circle text-white font-size-20">
                        <i class="bx bx-user-circle"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Active Members -->
            <div class="col-lg-2 col-md-4">
              <div class="card blog-stats-wid">
                <div class="card-body">
                  <div class="d-flex flex-wrap">
                    <div class="me-3">
                      <p class="text-muted mb-2">Active Members</p>
                      <h5 class="mb-0">987</h5>
                    </div>
                    <div class="avatar-sm ms-auto">
                      <div class="avatar-title bg-success rounded-circle text-white font-size-20">
                        <i class="bx bx-check-circle"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Inactive Members -->
            <div class="col-lg-2 col-md-4">
              <div class="card blog-stats-wid">
                <div class="card-body">
                  <div class="d-flex flex-wrap">
                    <div class="me-3">
                      <p class="text-muted mb-2">Inactive Members</p>
                      <h5 class="mb-0">185</h5>
                    </div>
                    <div class="avatar-sm ms-auto">
                      <div class="avatar-title bg-danger rounded-circle text-white font-size-20">
                        <i class="bx bx-x-circle"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Average Family Size -->
            <div class="col-lg-2 col-md-4">
              <div class="card blog-stats-wid">
                <div class="card-body">
                  <div class="d-flex flex-wrap">
                    <div class="me-3">
                      <p class="text-muted mb-2">Avg. Family Size</p>
                      <h5 class="mb-0">4.2</h5>
                    </div>
                    <div class="avatar-sm ms-auto">
                      <div class="avatar-title bg-info rounded-circle text-white font-size-20">
                        <i class="bx bx-group"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Total Payments Collected -->
            <div class="col-lg-2 col-md-4">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="d-flex flex-wrap">
                    <div class="me-3">
                      <p class="text-muted mb-2">Total Payments</p>
                      <h5 class="mb-0">247,850 <small>ETB</small></h5>
                    </div>
                    <div class="avatar-sm ms-auto">
                      <div class="avatar-title bg-purple rounded-circle text-white font-size-20">
                        <i class="bx bx-money"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Members with Outstanding Payments -->
            <div class="col-lg-2 col-md-4">
              <div class="card blog-stats-wid">
                <div class="card-body">
                  <div class="d-flex flex-wrap">
                    <div class="me-3">
                      <p class="text-muted mb-2">Outstanding Payments</p>
                      <h5 class="mb-0">125</h5>
                    </div>
                    <div class="avatar-sm ms-auto">
                      <div class="avatar-title bg-warning rounded-circle text-white font-size-20">
                        <i class="bx bx-calendar-exclamation"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row d-no">


            <div class="col-12">
              <div class="card">
                <div
                    class="card-header bg-white d-flex justify-content-between align-items-center w-100 border-bottom-1 pb-3 border-bottom-1 border-bottom">
                  <!-- filters -->
                  <div class="me-3 text-nowrap filter-tool-bar-btns">
                    <!-- Hide Fields -->
                    <div class="btn-group">
                      <button type="button" class="btn btn-light waves-effect me-2"
                              data-bs-toggle="dropdown" aria-expanded="false">
                        <i class="bx bxs-hide font-size-16 me-1 align-middle"></i> Hide Fields
                      </button>
                      <div class="dropdown-menu p-4" style="width: 300px;">
                        <div class="row">
                          <div class="col-12">
                            <h5 class="text-capitalize mb-0">Column Visibility</h5>
                          </div>
                          <div class="col-12 mb-2">
                            <hr>
                          </div>
                          <div class="col-12">
                            <!-- List of columns with toggles -->
                            <div class="form-check form-switch mb-2">
                              <input class="form-check-input toggle-column"
                                     type="checkbox" id="column-document" data-column="0"
                                     checked>
                              <label class="form-check-label"
                                     for="column-document">Document</label>
                            </div>
                            <div class="form-check form-switch mb-2">
                              <input class="form-check-input toggle-column"
                                     type="checkbox" id="column-period" data-column="1"
                                     checked>
                              <label class="form-check-label"
                                     for="column-period">Period</label>
                            </div>
                            <div class="form-check form-switch mb-2">
                              <input class="form-check-input toggle-column"
                                     type="checkbox" id="column-bank" data-column="2"
                                     checked>
                              <label class="form-check-label"
                                     for="column-bank">Bank/Source</label>
                            </div>
                            <div class="form-check form-switch mb-2">
                              <input class="form-check-input toggle-column"
                                     type="checkbox" id="column-amount" data-column="3"
                                     checked>
                              <label class="form-check-label" for="column-amount">Amounts
                                (ETB)</label>
                            </div>
                            <div class="form-check form-switch mb-2">
                              <input class="form-check-input toggle-column"
                                     type="checkbox" id="column-status" data-column="4"
                                     checked>
                              <label class="form-check-label"
                                     for="column-status">Status</label>
                            </div>
                            <div class="form-check form-switch mb-2">
                              <input class="form-check-input toggle-column"
                                     type="checkbox" id="column-uploaded" data-column="5"
                                     checked>
                              <label class="form-check-label"
                                     for="column-uploaded">Uploaded Date</label>
                            </div>
                            <div class="form-check form-switch mb-2">
                              <input class="form-check-input toggle-column"
                                     type="checkbox" id="column-uploaded-by" data-column="6"
                                     checked>
                              <label class="form-check-label"
                                     for="column-uploaded-by">Uploaded By</label>
                            </div>
                          </div>
                          <div class="col-12">
                            <button type="button" id="showAllColumns"
                                    class="btn btn-sm btn-outline-primary me-2">Show
                              All</button>
                            <button type="button" id="hideAllColumns"
                                    class="btn btn-sm btn-outline-danger">Hide All</button>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Sort Options -->
                    <div class="btn-group">
                      <button type="button" class="btn btn-light waves-effect"
                              data-bs-toggle="dropdown" aria-expanded="false">
                        <i class="bx bx-sort font-size-16 me-1 align-middle"></i> Sort
                      </button>
                      <div class="dropdown-menu p-4" style="width: 300px;">
                        <div class="row">
                          <div class="col-12">
                            <h5 class="text-capitalize mb-0">Sort By</h5>
                          </div>
                          <div class="col-12 mb-2">
                            <hr>
                          </div>
                          <div class="col-12">
                            <div class="mb-3">
                              <label for="sort-field-select"
                                     class="form-label">Field</label>
                              <select class="form-select" id="sort-field-select">
                                <option value="" selected disabled>Select field</option>
                                <option value="0">Document</option>
                                <option value="1">Period</option>
                                <option value="2">Bank/Source</option>
                                <option value="3">Amounts (ETB)</option>
                                <option value="4">Status</option>
                                <option value="5">Uploaded Date</option>
                                <option value="6">Uploaded By</option>
                              </select>
                            </div>
                          </div>
                          <div class="col-12">
                            <div class="mb-3">
                              <div class="btn-group" role="group">
                                <input type="radio" class="btn-check"
                                       name="sortDirection" id="sort-asc" value="asc"
                                       autocomplete="off" checked>
                                <label class="btn btn-outline-secondary"
                                       for="sort-asc"><i class="bx bx-sort-up"></i>
                                  Ascending</label>

                                <input type="radio" class="btn-check"
                                       name="sortDirection" id="sort-desc" value="desc"
                                       autocomplete="off">
                                <label class="btn btn-outline-secondary"
                                       for="sort-desc"><i class="bx bx-sort-down"></i>
                                  Descending</label>
                              </div>
                            </div>
                          </div>
                          <div class="col-12 mt-4">
                            <button type="button" id="applySort"
                                    class="btn btn-primary w-100">Apply Sort</button>
                          </div>
                          <div class="col-12 mt-2">
                            <button type="button" id="clearSort"
                                    class="btn btn-outline-danger w-100"><i
                                class="bx bx-trash me-1"></i> Clear Sort</button>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Date Filter -->
                    <div class="btn-group">
                      <button type="button" class="btn btn-light waves-effect mx-2"
                              data-bs-toggle="dropdown" aria-expanded="false">
                        <i class="bx bx-calendar font-size-16 me-1 align-middle"></i> Date Range
                      </button>
                      <div class="dropdown-menu p-4" style="width: 300px;">
                        <div class="row">
                          <div class="col-12">
                            <h5 class="text-capitalize mb-0">Filter by Date</h5>
                          </div>
                          <div class="col-12 mb-2">
                            <hr>
                          </div>
                          <div class="col-12">
                            <div class="mb-3">
                              <label for="start-date-input" class="form-label">Start
                                Date</label>
                              <input type="date" class="form-control"
                                     id="start-date-input">
                            </div>
                          </div>
                          <div class="col-12">
                            <div
                                class="d-flex align-items-center justify-content-center w-100">
                              <i class="bx bx-transfer-alt rotate-90 h2 text-info"></i>
                            </div>
                          </div>
                          <div class="col-12">
                            <div class="mb-3">
                              <label for="end-date-input" class="form-label">End
                                Date</label>
                              <input type="date" class="form-control" id="end-date-input">
                            </div>
                          </div>
                          <div class="col-12 mt-4">
                            <button type="button" id="applyDateFilter"
                                    class="btn btn-primary w-100">Apply Filter</button>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Active Filters -->
                    <button type="button" data-toggle="modal" data-target="#filtering-modal"
                            class="btn btn-light waves-effect active">
                      <i class="bx bx-filter font-size-16 me-1 align-middle"></i> 2 Filters
                    </button>
                  </div>


                  <div class="btn-toolbar d-flex justify-content-between align-items-center w-100"
                       role="toolbar">
                    <div class="flex-grow-1">
                      <div class="search-box mb-0 me-3">
                        <div class="position-relative">
                          <input type="text" id="searchInput"
                                 class="form-control bg-light border-light rounded"
                                 placeholder="Search..." spellcheck="false">
                          <i class="bx bx-search-alt search-icon"></i>
                        </div>
                      </div>
                    </div>

                    <div class="d-flex">
                      <button type="button" class="btn btn-success me-3" data-bs-toggle="modal"
                              data-bs-target="#statementUploadModal">
                        <i class="fas fa-upload me-2"></i>
                        Upload Statement
                      </button>
                      <button type="button"
                              class="btn btn-primary dropdown-toggle option-selector text-capitalize">
                        <i class="bx bxs-download"></i> <span class="pl-1 d-md-inline">Download
                                                    Report</span>
                      </button>
                    </div>
                  </div>
                </div>

                <div class="card-body">
                  <div class="table-responsive">
                    <table
                        class="table align-middle table-hover border table-striped text-nowrap mb-0"
                        id="policyPaymentsTable">
                      <thead class="table-light">
                      <tr>
                        <th scope="col">No.</th>
                        <th scope="col">Source</th>
                        <th scope="col">Bank Name</th>
                        <th scope="col">Account Name</th>
                        <th scope="col">Account Number</th>
                        <th scope="col" class="text-center">Flagged Transactions</th>
                        <th class="text-end">Affected Amount</th>
                        <th scope="col" class="text-center">Actions</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr>
                        <td>1.</td>
                        <td>Mobile Money</td>
                        <td>MPESA</td>
                        <td>Premium Mesa Account</td>
                        <td>7576565</td>
                        <td class="text-center">34</td>
                        <td class="text-end"><span class="fw-bold text-black">ETB
                                                            34,000</span></td>
                        <td class="text-center">
                          <a href="members-flagged-details.html"
                             class="btn btn-primary btn-sm">View</a>
                        </td>
                      </tr>
                      <tr>
                        <td>2.</td>
                        <td>Bank Transfer</td>
                        <td>Commercial Bank of Ethiopia</td>
                        <td>CBHI Woreda 12</td>
                        <td>1122334455</td>
                        <td class="text-center">12</td>
                        <td class="text-end"><span class="fw-bold text-black">ETB
                                                            18,750</span></td>
                        <td class="text-center">
                          <a href="members-flagged-details.html"
                             class="btn btn-primary btn-sm">View</a>
                        </td>
                      </tr>
                      <tr>
                        <td>3.</td>
                        <td>Cash Deposit</td>
                        <td>Dashen Bank</td>
                        <td>Woreda 9 Health Fund</td>
                        <td>9988776655</td>
                        <td class="text-center">5</td>
                        <td class="text-end"><span class="fw-bold text-black">ETB
                                                            5,250</span></td>
                        <td class="text-center">
                          <a href="members-flagged-details.html"
                             class="btn btn-primary btn-sm">View</a>
                        </td>
                      </tr>
                      <tr>
                        <td>4.</td>
                        <td>Mobile Money</td>
                        <td>Telebirr</td>
                        <td>CBHI Telebirr Account</td>
                        <td>4433221100</td>
                        <td class="text-center">27</td>
                        <td class="text-end"><span class="fw-bold text-black">ETB
                                                            21,000</span></td>
                        <td class="text-center">
                          <a href="members-flagged-details.html"
                             class="btn btn-primary btn-sm">View</a>
                        </td>
                      </tr>
                      <tr>
                        <td>5.</td>
                        <td>Bank Transfer</td>
                        <td>Awash Bank</td>
                        <td>Woreda 3 Premiums</td>
                        <td>3344556677</td>
                        <td class="text-center">8</td>
                        <td class="text-end"><span class="fw-bold text-black">ETB
                                                            9,880</span></td>
                        <td class="text-center">
                          <a href="members-flagged-details.html"
                             class="btn btn-primary btn-sm">View</a>
                        </td>
                      </tr>
                      </tbody>
                    </table>


                  </div>
                </div>
              </div>
            </div>
            <!-- end col -->
          </div>
        </div>
        <!-- container-fluid -->
      </div>
      <!-- End Page-content -->
      <!-- upload modal -->
      <div class="modal fade" id="statementUploadModal" tabindex="-1" aria-labelledby="statementUploadModalLabel"
           aria-hidden="true">
        <div class="modal-dialog modal-lg modal-dialog-centered">
          <div class="modal-content">
            <!-- Modal Header -->
            <div class="modal-header">
              <h5 class="modal-title" id="statementUploadModalLabel">

                Upload Statement
              </h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>

            <!-- Modal Body -->
            <div class="modal-body">
              <form id="statementForm">
                <!-- File Upload Section -->
                <div class="mb-4">
                  <label class="form-label">
                    Select Statement File <span class="text-danger">*</span>
                  </label>
                  <div id="dropZone" class="file-drop-zone">
                    <div id="fileDisplay" class="d-none">
                      <div class="d-flex align-items-center justify-content-center">
                        <i id="fileIcon" class="fas fa-file-excel fs-1 text-success me-3"></i>
                        <div>
                          <div id="fileName" class="fw-bold"></div>
                          <small id="fileSize" class="text-muted"></small>
                        </div>
                      </div>
                    </div>
                    <div id="uploadPrompt">
                      <i class="fas fa-cloud-upload-alt fa-3x text-muted mb-3"></i>
                      <p class="mb-2">Drop your file here or click to browse</p>
                      <small class="text-muted">Excel (.xlsx, .xls) or CSV files only</small>
                    </div>
                    <input type="file" id="fileInput" accept=".xlsx,.xls,.csv"
                           class="file-input-overlay">
                  </div>
                </div>

                <!-- Statement Type -->
                <div class="mb-3">
                  <label for="statementType" class="form-label">
                    Statement Type <span class="text-danger">*</span>
                  </label>
                  <select class="form-select" id="statementType" required>
                    <option value="">Select statement type</option>
                    <option value="Bank">Bank</option>
                    <option value="MPESA">MPESA</option>
                    <option value="Telebirr">Telebirr</option>
                  </select>
                </div>

                <!-- Upload Reason -->
                <div class="mb-3">
                  <label for="uploadReason" class="form-label">
                    Reason for Upload <span class="text-danger">*</span>
                  </label>
                  <select class="form-select" id="uploadReason" required>
                    <option value="">Select reason</option>
                    <option value="Monthly Reconciliation">Monthly Reconciliation</option>
                    <option value="Audit Requirements">Audit Requirements</option>
                    <option value="Financial Review">Financial Review</option>
                    <option value="Budget Analysis">Budget Analysis</option>
                    <option value="Compliance Check">Compliance Check</option>
                    <option value="Other">Other</option>
                  </select>
                </div>

                <!-- Account Selection -->
                <div class="mb-3">
                  <label for="accountSelect" class="form-label">
                    Select Account <span class="text-danger">*</span>
                  </label>
                  <select class="form-select" id="accountSelect" required>
                    <option value="">Select account</option>
                    <option value="1">General Hospital - Addis Ketema</option>
                    <option value="2">Tikur Anbessa - Kirkos</option>
                    <option value="3">Black Lion - Gulele</option>
                    <option value="4">Yekatit 12 - Arada</option>
                    <option value="5">Gandhi Memorial - Bole</option>
                  </select>

                </div>

                <!-- Selected Account Details -->
                <div id="accountDetails" class="account-details d-none">
                  <h6 class="mb-3">
                    <i class="fas fa-info-circle me-2"></i>
                    Selected Account Details
                  </h6>
                  <div class="row">
                    <div class="col-md-6">
                      <p class="mb-2"><strong>Account Name:</strong> <span id="detailName"></span>
                      </p>
                      <p class="mb-2"><strong>Hospital:</strong> <span id="detailHospital"></span>
                      </p>
                    </div>
                    <div class="col-md-6">
                      <p class="mb-2"><strong>Woreda:</strong> <span id="detailWoreda"></span></p>
                      <p class="mb-2"><strong>Account Number:</strong> <span
                          id="detailAccountNumber"></span></p>
                    </div>
                  </div>
                </div>
              </form>
            </div>

            <!-- Modal Footer -->
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
                <i class="fas fa-times me-2"></i>
                Cancel
              </button>
              <button type="button" class="btn btn-primary" id="submitBtn">
                <i class="fas fa-upload me-2"></i>
                Upload Statement
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- modals start -->
      <div class="modal fade" id="invoiceModal" tabindex="-1" role="dialog"
           aria-labelledby="exampleModalCenterTitle" aria-hidden="true" data-bs-backdrop="static"
           data-bs-keyboard="false">
        <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
          <div class="modal-content  transaction-content">
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLongTitle">Membership registration payment</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body ">
              <div class="row">
                <div class="col-sm-12 col-md-7 mb-3">
                  <div class="table-responsive bg-light p-4 h-100">
                    <table class="table table-light ">
                      <thead class="">
                      <tr style="border-bottom: 5px solid black;">
                        <th colspan="4" class="text-capitalize">
                          <h4 class="mb-0 fw-bold text-black">Invoicing details</h4>
                          <p class="mb-0 ">Primary Meber Kelvin Kelly</p>
                        </th>
                      </tr>
                      </thead>
                      <thead>
                      <tr>
                        <th>#</th>
                        <th>Item</th>
                        <th>QTY</th>
                        <th class="text-right">Amount</th>
                      </tr>
                      </thead>
                      <tbody class="border-dushed">
                      <tr>
                        <td><strong>1.</strong></td>
                        <td>Membership Application Fee</td>
                        <td><span class="standardQuantity">1</span></td>
                        <td class="text-right text-dark fw-semibold"><strong>ETB <span
                            class="cbh-application">25</span> </strong></td>
                      </tr>

                      <tr>
                        <td><strong>2.</strong></td>
                        <td>Standard CBHI membership fee</td>
                        <td><span class="standard-qty">-</span></td>
                        <td class="text-right text-dark fw-semibold"><strong>ETB <span
                            class="std-fee">25</span></strong></td>
                      </tr>

                      <tr>
                        <td><strong>3.</strong></td>
                        <td>Extra Members</td>
                        <td><span class="extra-qty">-</span></td>
                        <td class="text-right text-dark fw-semibold"><strong>ETB <span
                            class="extra-total">25</span></strong></td>
                      </tr>

                      </tbody>
                      <tfoot class="">
                      <tr
                          style="border-top: 3px solid black; border-bottom: 3px solid black;">

                        <th class="text-right text-dark fw-bold" colspan="4">
                          <small class="text-uppercase">Sub totals</small>
                          <h4 class="mb-0">ETB <span class="text-dark cbh-total">-</span>
                          </h4>
                        </th>
                      </tr>
                      </tfoot>
                    </table>

                    <div>
                      <div class="alert alert-warning border-warning border-2 text-black"
                           role="alert">
                        <strong>Attention:</strong> Payment is pending for this invoice. Kindly
                        settle it to avoid service interruption.
                      </div>
                    </div>

                  </div>

                </div>

                <div class="col-sm-12 col-md-5 mb-3">
                  <div class="p-3 rounded-1 border border-dashed border-gray-5 py-4">
                    <h4 class="mb-0 pb-0 fw-semibold d-block">Select Payment Method</h4>
                    <p class="pb-0 mb-0">
                                            <span class="text-muted">Ask the member: <em>How would you like to make this
                                                    premium payment?</em></span><br>
                    </p>
                  </div>


                  <div class="accordion mt-3" id="accordionExample">
                    <!-- Mobile Money Wallet -->
                    <div class="accordion-item">
                      <h2 class="accordion-header" id="headingOne">
                        <button class="accordion-button fw-medium" type="button"
                                data-bs-toggle="collapse" data-bs-target="#collapseOne"
                                aria-expanded="true" aria-controls="collapseOne">
                          <div class="flex-shrink-0 me-3">
                            <img class="rounded-circle"
                                 src="assets/images/users/mobile_money.png"
                                 alt="Mobile Money" height="65">
                          </div>
                          <div class="d-flex flex-column">
                            <p class="m-0 p-0 text-uppercase fw-semibold">Mobile Money
                              Wallets</p>
                            <p class="mb-0 p-0"><small>Use this option for clients using
                              Telebirr or MPESA</small></p>
                          </div>
                        </button>
                      </h2>
                      <div id="collapseOne" class="accordion-collapse collapse show"
                           aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                        <div class="accordion-body">
                          <p>
                            A payment request of <strong class="text-black">ETB <span
                              class="cbh-total">-</span></strong> will be sent to the
                            mobile number provided, depending on the selected wallet.
                          </p>
                          <div class="form-group mb-3">
                            <label for="wallet">Select Mobile Wallet</label>
                            <select class="form-select" id="wallet">
                              <option value="telebirr">Telebirr</option>
                              <option value="mpesa">MPESA</option>
                            </select>
                          </div>
                          <div class="form-group">
                            <label for="phone-input">Mobile Number</label>
                            <div class="form-floating mb-3">
                              <input type="text"
                                     class="form-control font-21 text-success form-control-lg"
                                     id="phone-input" placeholder="Enter Phone Number">
                              <label for="phone-input">Phone Number</label>
                            </div>
                          </div>

                          <div class="mt-3">
                            <button
                                class="btn btn-primary w-100 text-uppercase bank-nxt-bank btn-finish">Send
                              Prompt</button>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Cash Payment -->
                    <div class="accordion-item">
                      <h2 class="accordion-header" id="headingFour">
                        <button class="accordion-button fw-medium collapsed" type="button"
                                data-bs-toggle="collapse" data-bs-target="#collapseFour"
                                aria-expanded="false" aria-controls="collapseFour">
                          <div class="flex-shrink-0 me-3">
                            <img class="rounded-circle" src="assets/images/users/money.jpg"
                                 alt="Cash Payment" height="65">
                          </div>
                          <div class="d-flex flex-column">
                            <p class="m-0 p-0 text-uppercase fw-semibold">CASH</p>
                            <p class="mb-0 p-0"><small>Use this option when you have
                              received direct cash payment from the client</small></p>
                          </div>
                        </button>
                      </h2>
                      <div id="collapseFour" class="accordion-collapse collapse"
                           aria-labelledby="headingFour" data-bs-parent="#accordionExample">
                        <div class="accordion-body">
                          <div class="cash-inputs">
                            <div class="mb-3">
                              <label for="cash-amount">Amount Received (ETB)</label>
                              <div class="form-floating">
                                <input type="text"
                                       class="form-control font-21 text-success form-control-lg"
                                       id="cash-amount" placeholder="Enter Amount">
                                <label for="cash-amount">Enter Amount Received</label>
                              </div>
                            </div>

                            <div class="alert alert-info mb-3">
                              <i class="bx bx-info-circle me-2"></i>
                              An OTP will be sent to your registered phone number to
                              verify that you have received this cash payment.
                            </div>

                            <div class="form-check form-check-primary mb-3">
                              <input class="form-check-input" type="checkbox"
                                     id="confirm-cash-payment">
                              <label class="form-check-label" for="confirm-cash-payment">
                                I confirm that I have received cash payment of
                                <strong>ETB <span class="cbh-total">-</span></strong>
                                from the client and am authorized to process this
                                transaction
                              </label>
                            </div>

                            <button
                                class="btn btn-primary w-100 text-uppercase cash-continue-btn">Continue</button>
                          </div>

                          <div class="cash-otp-input d-none">
                            <p>
                              An OTP has been sent to your registered phone number. Please
                              check your SMS to complete the verification.
                              <a href="#">Click here to resend OTP</a>.
                            </p>
                            <div class="form-group">
                              <label for="cash-otp-input">OTP</label>
                              <div class="form-floating mb-3">
                                <input type="text"
                                       class="form-control font-21 text-success form-control-lg cash-otp-code"
                                       id="cash-otp-input" placeholder="Enter OTP">
                                <label for="cash-otp-input">Enter the OTP sent to your
                                  phone</label>
                              </div>
                            </div>

                            <div class="d-flex justify-content-end">
                              <button type="button"
                                      class="btn btn-light me-3 cash-edit-btn">
                                <i
                                    class="bx bxs-edit-alt font-size-16 align-middle me-2"></i>
                                Edit
                              </button>
                              <button type="button"
                                      class="btn btn-primary cash-submit-btn btn-finish"
                                      disabled>
                                Complete Payment <i
                                  class="bx bx-right-arrow-alt font-size-16 align-middle"></i>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- qr code payment method -->
                    <div class="accordion-item">
                      <h2 class="accordion-header" id="headingTwo">
                        <button class="accordion-button fw-medium collapsed" type="button"
                                data-bs-toggle="collapse" data-bs-target="#collapseTwo"
                                aria-expanded="false" aria-controls="collapseTwo">
                          <div class="flex-shrink-0 me-3">
                            <img class="rounded-circle"
                                 src="assets/images/users/qrCodePay.png" alt="Bank Payment"
                                 height="65">
                          </div>
                          <div class="d-flex flex-column">
                            <p class="m-0 p-0 text-uppercase fw-semibold">Bank QR Payment
                            </p>
                            <p class="mb-0 p-0">
                              <small>
                                Show QR. Client scans with bank app. Payment
                                auto-validates.
                              </small>


                            </p>
                          </div>

                        </button>
                      </h2>
                      <div id="collapseTwo" class="accordion-collapse collapse"
                           aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
                        <div class="accordion-body">
                          <p class="fw-bold text-black text-center">Scan below to initiate QR
                            code Payment</p>
                          <div>
                            <img src="assets/images/qrCode.png" class="img w-100" alt="">
                          </div>

                          <div>
                            <button
                                class="btn btn-info w-100 mt-3 btn-finish">Process</button>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Bank Payment -->
                    <div class="accordion-item">
                      <h2 class="accordion-header" id="headingThree">
                        <button class="accordion-button fw-medium collapsed" type="button"
                                data-bs-toggle="collapse" data-bs-target="#collapseThree"
                                aria-expanded="false" aria-controls="collapseThree">
                          <div class="flex-shrink-0 me-3">
                            <img class="rounded-circle" src="assets/images/users/bank.png"
                                 alt="Bank Payment" height="65">
                          </div>
                          <div class="d-flex flex-column">
                            <p class="m-0 p-0 text-uppercase fw-semibold">BANK</p>
                            <p class="mb-0 p-0"><small>By selecting this option, you confirm
                              that the payment was received via bank or direct cash
                              deposit</small></p>
                          </div>
                        </button>
                      </h2>
                      <div id="collapseThree" class="accordion-collapse collapse"
                           aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
                        <div class="accordion-body">
                          <div class="bank-inputs">
                            <div class="mb-3">
                              <label for="">Select Bank</label>
                              <select class="form-select">
                                <option disabled selected>Select Bank Account</option>
                                <option>Tsede Bank - 3344556677</option>
                              </select>
                            </div>

                            <div class="mb-3">
                              <label for="">Bank Reference Number</label>
                              <input type="text" class="form-control"
                                     placeholder="Enter Ref No.">
                            </div>

                            <div class="mb-3">
                              <label for="">Payer's Full Name</label>
                              <input type="text" class="form-control"
                                     placeholder="Enter Full Name">
                            </div>

                            <div class="mb-3">
                              <label for="">Payer's Phone Number</label>
                              <input type="text" class="form-control"
                                     placeholder="Enter Phone Number">
                            </div>

                            <div class="form-check form-check-primary mb-3">
                              <input class="form-check-input" type="checkbox"
                                     id="confirm-cash">
                              <label class="form-check-label" for="confirm-cash">
                                I confirm that I have received the bank deposit or
                                cheque payment of <strong>ETB <span
                                  class="cbh-total">-</span></strong> from the
                                client
                              </label>
                            </div>

                            <button
                                class="btn btn-primary w-100 text-uppercase bank-nxt-bank">Next</button>
                          </div>

                          <div class="bank-input d-none">
                            <p>
                              An OTP has been sent to the client's phone number: <strong
                                class="text-black">0912345678</strong>. Please ask them
                              to check their SMS.
                              <a href="#">Click here to resend OTP</a>.
                            </p>
                            <div class="form-group">
                              <label for="">OTP</label>
                              <div class="form-floating mb-3">
                                <input type="text"
                                       class="form-control font-21 text-success form-control-lg bank-otp-input"
                                       id="otp-input" placeholder="Enter OTP">
                                <label for="otp-input">Enter OTP sent to client's
                                  phone</label>
                              </div>
                            </div>

                            <div class="d-flex justify-content-end">
                              <button type="button"
                                      class="btn btn-light me-3 btn-otp-edit">
                                <i
                                    class="bx bxs-edit-alt font-size-16 align-middle me-2"></i>
                                Edit
                              </button>
                              <button type="button" class="btn btn-primary btn-otp-submit"
                                      disabled>
                                Next <i
                                  class="bx bx-right-arrow-alt font-size-16 align-middle"></i>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>


                  </div>
                </div>

              </div>
            </div>
          </div>
          <div class="modal-loader modal-content d-none">
            <div class="row">
              <div class="col-12 processing-transaction">
                <div
                    class="text-center d-flex w-100 h-100 align-center justify-items-center flex-column">
                  <div class="mb-4">
                    <div class="spinner-chase">
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                    </div>
                  </div>
                  <h4>Processing Transaction</h4>
                  <p>Be patient as the transaction is being processed. This may take a few seconds</p>
                </div>
              </div>

              <!-- show for a transaction that went through -->
              <div
                  class="col-12 trans-succesfull bg-light border-top p-5 p-sm-3 border border-dashed border-success d-none flex-wrap border-radius-10">
                <div
                    class="text-center d-flex w-100 h-100 align-items-center justify-content-center flex-column">
                  <div class="mb-4">
                    <span class="mdi mdi-check-circle-outline text-success display-2"></span>
                  </div>
                  <h4 class="fw-bold">Registration & Payment Successful</h4>
                  <p class="text-muted mb-2">
                    The member has been successfully registered and their premium payment received.
                  </p>
                  <p class="text-muted">
                    <strong>Membership/Card Number:</strong> <span
                      id="card-number">CBH123456789</span>
                  </p>
                  <p class="text-muted mb-4">
                    You may now download the receipt or close this window.
                  </p>

                  <div class="d-flex gap-3">
                    <button class="btn btn-outline-secondary" type="button" data-dismiss="modal"
                            aria-label="Close">Close</button>
                    <button class="btn btn-primary" type="button"
                            >Download Receipt</button>
                  </div>
                </div>
              </div>



            </div>
          </div>
        </div>
      </div>
      <!-- modal end -->

      <!-- filters modal -->
      <!-- Filter Modal -->
      <div class="modal fade" id="filtering-modal" tabindex="-1" aria-labelledby="filterModalLabel"
           aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-lg">
          <div class="modal-content">
            <!-- Modal Header -->
            <div class="modal-header">
              <h5 class="modal-title" id="filterModalLabel">Filter Reconciliations</h5>
              <button type="button" class="btn-close bg-white" data-bs-dismiss="modal"
                      aria-label="Close"></button>
            </div>

            <!-- Modal Body -->
            <div class="modal-body">
              <div class="row g-3">
                <!-- Reconciliation Status -->
                <div class="col-md-6">
                  <h6 class="text-uppercase">Reconciliation Status</h6>
                  <div class="form-check">
                    <input class="form-check-input" type="checkbox" id="statusAll" checked>
                    <label class="form-check-label" for="statusAll">All Statuses</label>
                  </div>
                  <div class="form-check">
                    <input class="form-check-input" type="checkbox" id="statusPending">
                    <label class="form-check-label" for="statusPending">Pending</label>
                  </div>
                  <div class="form-check">
                    <input class="form-check-input" type="checkbox" id="statusApproved">
                    <label class="form-check-label" for="statusApproved">Approved</label>
                  </div>
                  <div class="form-check">
                    <input class="form-check-input" type="checkbox" id="statusRejected">
                    <label class="form-check-label" for="statusRejected">Rejected</label>
                  </div>
                </div>

                <!-- Reconciliation Date Range -->
                <div class="col-md-6">
                  <h6 class="text-uppercase">Reconciliation Date</h6>
                  <div class="row g-2">
                    <div class="col">
                      <label for="reconciliationStartDate" class="form-label">From</label>
                      <input type="date" class="form-control" id="reconciliationStartDate">
                    </div>
                    <div class="col">
                      <label for="reconciliationEndDate" class="form-label">To</label>
                      <input type="date" class="form-control" id="reconciliationEndDate">
                    </div>
                  </div>
                </div>

                <!-- Reconciled Amount Range -->
                <div class="col-md-6">
                  <h6 class="text-uppercase">Reconciled Amount (ETB)</h6>
                  <div class="row g-2">
                    <div class="col">
                      <label for="minAmount" class="form-label">Min</label>
                      <input type="number" class="form-control" id="minAmount" placeholder="Min">
                    </div>
                    <div class="col">
                      <label for="maxAmount" class="form-label">Max</label>
                      <input type="number" class="form-control" id="maxAmount" placeholder="Max">
                    </div>
                  </div>
                </div>

                <!-- Agent Name -->
                <div class="col-md-6">
                  <h6 class="text-uppercase">Agent Name</h6>
                  <select class="form-select" id="agentName">
                    <option value="all" selected>All Agents</option>
                    <option value="agent1">Agent 1</option>
                    <option value="agent2">Agent 2</option>
                    <option value="agent3">Agent 3</option>
                  </select>
                </div>

                <!-- Account -->
                <div class="col-md-6">
                  <h6 class="text-uppercase">Account</h6>
                  <select class="form-select" id="account">
                    <option value="all" selected>All Accounts</option>
                    <option value="account1">Account 1</option>
                    <option value="account2">Account 2</option>
                    <option value="account3">Account 3</option>
                  </select>
                </div>

                <!-- Comments -->
                <div class="col-md-6">
                  <h6 class="text-uppercase">Comments</h6>
                  <input type="text" class="form-control" id="comments"
                         placeholder="Search Comments/Notes">
                </div>
              </div>
            </div>

            <!-- Modal Footer -->
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
                <i class="bx bx-x me-1"></i> Cancel
              </button>
              <button type="button" class="btn btn-primary" id="applyFilters">
                <i class="bx bx-filter me-1"></i> Apply Filters
              </button>
              <button type="button" class="btn btn-outline-secondary" id="resetFilters">
                <i class="bx bx-refresh me-1"></i> Reset Filters
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- end of filters modal -->

      <!-- Payment Details Modal -->
      <div class="modal fade" id="paymentDetailsModal" tabindex="-1" aria-labelledby="paymentDetailsModalLabel"
           aria-hidden="true">
        <div class="modal-dialog modal-xl">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="paymentDetailsModalLabel">
                Premium Payment Details
              </h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">

              <!-- Policy Holder Info -->
              <div
                  class="payment-detail-card payment-status-success rounded p-4 mb-4 border-success border badge-soft-success ">
                <div class="row">
                  <div class="col-md-8">
                    <div class="d-flex mb-3">
                      <div class="avatar-sm">
                                                <span class="avatar-title rounded-circle">
                                                    AT
                                                </span>
                      </div>
                      <div class="mx-3">
                        <h4 class="mb-1">Alemayehu Tesfaye</h4>
                        <p class="text-muted mb-1">Policy Number: <strong>POL-2024-001</strong>
                        </p>
                        <p class="text-muted mb-0">
                          <i class="bx bx-map me-1"></i>North Gondar, Gondar Zuria, Kebele 05
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4 text-md-end">
                    <div class="mb-2">
                                            <span class="badge bg-success fs-6 px-3 py-2">
                                                <i class="bx bx-check-circle me-1"></i>PAID IN FULL
                                            </span>
                    </div>
                    <div class="amount-highlight text-success">
                      <h1 class="fw-semibold display-6 mb-0 text-success">400 ETB</h1>
                    </div>
                    <p class="text-muted">Annual Premium</p>
                  </div>
                </div>
              </div>

              <!-- Payment Summary -->
              <div class="row mb-4">
                <div class="col-md-6">
                  <div class="card h-100 border">
                    <div class="card-header bg-light">
                      <h6 class="mb-"><i class="bx bx-info-circle me-1"></i>Policy Information
                      </h6>
                    </div>
                    <div class="card-body border">
                      <table class="table table-borderless table-sm">
                        <tr>
                          <td class="text-muted">Family Size:</td>
                          <td><span class="badge bg-info">3 Members</span></td>
                        </tr>
                        <tr>
                          <td class="text-muted">Registration Date:</td>
                          <td>15 January 2024</td>
                        </tr>
                        <tr>
                          <td class="text-muted">Policy Year:</td>
                          <td>2024-2025</td>
                        </tr>
                        <tr>
                          <td class="text-muted">Coverage Period:</td>
                          <td>15 Jan 2025 - 14 Jan 2026</td>
                        </tr>
                        <tr>
                          <td class="text-muted">Registered By:</td>
                          <td>Mulugeta Asfaw</td>
                        </tr>
                      </table>
                    </div>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="card h-100 border">
                    <div class="card-header bg-light">
                      <h6 class="mb-"><i class="bx bx-calculator me-1"></i>Payment Breakdown</h6>
                    </div>
                    <div class="card-body border">
                      <table class="table table-borderless table-sm">
                        <tr>
                          <td class="text-muted">Base Premium (4 members):</td>
                          <td class="text-end">400 ETB</td>
                        </tr>
                        <tr>
                          <td class="text-muted">Additional Members (0):</td>
                          <td class="text-end">0 ETB</td>
                        </tr>
                        <tr>
                          <td class="text-muted">Discount/Adjustment:</td>
                          <td class="text-end">0 ETB</td>
                        </tr>
                        <tr class="border-top">
                          <td class="fw-bold">Total Annual Premium:</td>
                          <td class="text-end fw-bold text-primary">400 ETB</td>
                        </tr>
                        <tr>
                          <td class="text-success fw-bold">Amount Paid:</td>
                          <td class="text-end text-success fw-bold">400 ETB</td>
                        </tr>
                        <tr>
                          <td class="text-muted">Balance Remaining:</td>
                          <td class="text-end">0 ETB</td>
                        </tr>
                      </table>
                    </div>
                  </div>
                </div>
              </div>


              <!-- Payment History Timeline -->
              <div class="card mb-4 border">
                <div class="card-header bg-light">
                  <h6 class="mb-"><i class="bx bx-history me-1"></i>Payment History</h6>
                </div>
                <div class="card-body border">
                  <div>
                    <ul class="verti-timeline list-unstyled">

                      <!-- First Payment -->
                      <li class="event-list">
                        <div class="event-timeline-dot success">
                          <i class="bx bx-money text-success"></i>
                        </div>
                        <div class="timeline-content">
                          <div class="d-flex">
                            <div class="flex-shrink-0 me-3">
                              <div class="bg-success bg-opacity-10 rounded-circle p-2">
                                <i class="bx bx-wallet h2 text-success mb-0"></i>
                              </div>
                            </div>
                            <div class="flex-grow-1">
                              <div>
                                <h5 class="font-size-16 text-success mb-1">Payment
                                  Received</h5>
                                <p class="text-muted mb-2">Partial Payment of
                                  <strong>ETB 100</strong> against <strong>ETB
                                    400</strong></p>
                                <span class="text-muted">
                                                                    <i class="bx bx-time me-1"></i>14 January 2025,
                                                                    10:23 AM
                                                                </span>
                              </div>
                            </div>
                            <div class="text-end">
                              <h5 class="amount-display text-success">+100 ETB</h5>
                              <div
                                  class="d-flex align-items-center justify-content-end mb-1">
                                <i class="bx bx-mobile text-primary me-1"></i>
                                <small class="text-muted">Mobile Money</small>
                              </div>
                              <div><span
                                  class="badge bg-success text-uppercase">Confirmed</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </li>

                      <!-- Second Payment -->
                      <li class="event-list">
                        <div class="event-timeline-dot success">
                          <i class="bx bx-check-circle text-success"></i>
                        </div>
                        <div class="timeline-content">
                          <div class="d-flex">
                            <div class="flex-shrink-0 me-3">
                              <div class="bg-success bg-opacity-10 rounded-circle p-2">
                                <i class="bx bx-receipt h2 text-success mb-0"></i>
                              </div>
                            </div>
                            <div class="flex-grow-1">
                              <div>
                                <h5 class="font-size-16 text-success mb-1">Final Payment
                                </h5>
                                <p class="text-muted mb-2">Full premium payment
                                  completed <strong>300 ETB</strong> of remaining
                                  <strong>300 ETB</strong></p>
                                <span class="text-muted">
                                                                    <i class="bx bx-time me-1"></i>20 January 2025, 2:15
                                                                    PM
                                                                </span>
                              </div>
                            </div>
                            <div class="text-end">
                              <h5 class="amount-display text-success">+300 ETB</h5>
                              <div
                                  class="d-flex align-items-center justify-content-end mb-1">
                                <i class="bx bx-mobile text-primary me-1"></i>
                                <small class="text-muted">Mobile Money</small>
                              </div>
                              <div><span
                                  class="badge bg-success text-uppercase">Confirmed</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </li>

                      <!-- Policy Activation -->
                      <li class="event-list">
                        <div class="event-timeline-dot info">
                          <i class="bx bx-shield-check text-info"></i>
                        </div>
                        <div class="timeline-content">
                          <div class="d-flex">
                            <div class="flex-shrink-0 me-3">
                              <div class="bg-info bg-opacity-10 rounded-circle p-2">
                                <i class="bx bx-check-shield h2 text-info mb-0"></i>
                              </div>
                            </div>
                            <div class="flex-grow-1">
                              <div>
                                <h5 class="font-size-16 text-info mb-1">Policy Activated
                                </h5>
                                <p class="text-muted mb-2">Coverage period started - All
                                  benefits now active</p>
                                <span class="text-muted">
                                                                    <i class="bx bx-time me-1"></i>21 January 2025,
                                                                    12:00 AM
                                                                </span>
                              </div>
                            </div>
                            <div class="text-end">
                              <div class="mb-2">
                                <i class="bx bx-calendar-check text-info h4"></i>
                              </div>
                              <div><span
                                  class="badge bg-info text-uppercase">Active</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </li>

                      <!-- Additional Timeline Items for Different Scenarios -->

                      <!-- Reminder Sent -->
                      <li class="event-list">
                        <div class="event-timeline-dot warning">
                          <i class="bx bx-bell text-warning"></i>
                        </div>
                        <div class="timeline-content">
                          <div class="d-flex">
                            <div class="flex-shrink-0 me-3">
                              <div class="bg-warning bg-opacity-10 rounded-circle p-2">
                                <i class="bx bx-message-dots h2 text-warning mb-0"></i>
                              </div>
                            </div>
                            <div class="flex-grow-1">
                              <div>
                                <h5 class="font-size-16 text-warning mb-1">Payment
                                  Reminder Sent</h5>
                                <p class="text-muted mb-2">SMS reminder sent for
                                  upcoming payment deadline</p>
                                <span class="text-muted">
                                                                    <i class="bx bx-time me-1"></i>10 January 2025, 9:00
                                                                    AM
                                                                </span>
                              </div>
                            </div>
                            <div class="text-end">
                              <div class="mb-2">
                                <i class="bx bx-envelope text-warning h4"></i>
                              </div>
                              <div><span
                                  class="badge bg-warning text-uppercase">Sent</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </li>



                    </ul>
                  </div>
                </div>
              </div>

              <!-- Receipt Section -->
              <div class="receipt-section p-3 bg-light border-left-blue mb-3">
                <div class="row">
                  <div class="col-md-6">
                    <h6><i class="bx bx-receipt me-1"></i>Receipt Information</h6>
                    <table class="table table-borderless table-sm">
                      <tr>
                        <td class="text-muted">Receipt Number:</td>
                        <td><strong>RCP-2025-0012</strong></td>
                      </tr>
                      <tr>
                        <td class="text-muted">Transaction ID:</td>
                        <td>TXN-MM-20250112-001234</td>
                      </tr>
                      <tr>
                        <td class="text-muted">Payment Method:</td>
                        <td>
                                                    <span class="badge bg-primary">
                                                        <i class="bx bx-phone me-1"></i>Mobile Money
                                                    </span>
                        </td>
                      </tr>
                      <tr>
                        <td class="text-muted">Phone Number:</td>
                        <td>+251-911-123-456</td>
                      </tr>
                    </table>
                  </div>
                  <div class="col-md-6">
                    <h6><i class="bx bx-user me-1"></i>Collection Details</h6>
                    <table class="table table-borderless table-sm">
                      <tr>
                        <td class="text-muted">Collected By:</td>
                        <td>Mulugeta Asfaw</td>
                      </tr>
                      <tr>
                        <td class="text-muted">Agent ID:</td>
                        <td>AGT-001</td>
                      </tr>
                      <tr>
                        <td class="text-muted">Collection Date:</td>
                        <td>12 January 2025</td>
                      </tr>
                      <tr>
                        <td class="text-muted">Branch/Office:</td>
                        <td>Gondar Branch Office</td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>

              <!-- Family Members Covered -->
              <div class="card mb-4">
                <div class="card-header bg-light border">
                  <h6 class="mb-"><i class="bx bx-group me-1"></i>Family Members Covered</h6>
                </div>
                <div class="card-body border">
                  <div class="row">
                    <div class="col-md-6">
                      <table class="table table-sm">
                        <thead>
                        <tr>
                          <th>Name</th>
                          <th>Relationship</th>
                          <th>Age</th>
                          <th>Status</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                          <td>Alemayehu Tesfaye</td>
                          <td>Policy Holder</td>
                          <td>35</td>
                          <td><span class="badge bg-success">Covered</span></td>
                        </tr>
                        <tr>
                          <td>Tigist Alemayehu</td>
                          <td>Spouse</td>
                          <td>32</td>
                          <td><span class="badge bg-success">Covered</span></td>
                        </tr>
                        <tr>
                          <td>Dawit Alemayehu</td>
                          <td>Child</td>
                          <td>8</td>
                          <td><span class="badge bg-success">Covered</span></td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                    <div class="col-md-6">
                      <div class="alert alert-info">
                        <h6><i class="bx bx-info-circle me-1"></i>Coverage Summary</h6>
                        <ul class="mb-0">
                          <li>3 family members covered</li>
                          <li>Premium paid in full for 2025</li>
                          <li>Coverage valid until 14 Jan 2026</li>
                          <li>All benefits active</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Notes Section -->
              <div class="card">
                <div class="card-header bg-light border">
                  <h6 class="mb-"><i class="bx bx-note me-1"></i>Notes & Comments</h6>
                </div>
                <div class="card-body border">
                  <div class="mb-3">
                    <small class="text-muted">Agent Notes:</small>
                    <p class="mb-2">Payment received on time. Family expressed satisfaction with
                      services. Renewal reminder to be sent in December 2025.</p>
                  </div>
                  <div class="mb-3">
                    <small class="text-muted">System Notes:</small>
                    <p class="mb-0">Payment processed successfully. SMS confirmation sent to
                      registered mobile number.</p>
                  </div>


                </div>
              </div>
            </div>

            <div class="modal-footer no-print">
              <button type="button" class="btn btn-outline-primary" onclick="printReceipt()">
                <i class="bx bx-printer me-1"></i>Print Receipt
              </button>
              <button type="button" class="btn btn-outline-success">
                <i class="bx bx-download me-1"></i>Download PDF
              </button>
              <button type="button" class="btn btn-outline-info">
                <i class="bx bx-envelope me-1"></i>Email Receipt
              </button>
              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
                <i class="bx bx-x me-1"></i>Close
              </button>
            </div>
          </div>
        </div>
      </div>


      <footer class="footer ">
        <div class="container-fluid ">
          <div class="row ">
            <div class="col-sm-6 ">
              © CBHI
            </div>
            <div class="col-sm-6 ">
              <div class="text-sm-end d-sm-block ">
                Ministry of Health- Ethiopia
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
    <!-- end main content-->

  </div>
  <!-- END layout-wrapper -->

  <!-- Right bar overlay-->
  <div class="rightbar-overlay "></div>

  </body>

</template>

<script>
/* eslint-disable */
import NavigationBar from "@/components/Navigation.vue";

export default {
  name: "MembersFlagged",
  components: { NavigationBar },
  data() {
    return {

    };
  },

  mounted() {

  },

  watch: {

  },

  methods: {


  }
};
</script>

<style scoped>
.drag-active {
  border-color: #0d6efd !important;
  background-color: #e7f1ff !important;
}

.file-drop-zone {
  border: 2px dashed #dee2e6;
  border-radius: 0.375rem;
  padding: 3rem;
  text-align: center;
  transition: all 0.3s ease;
  cursor: pointer;
  position: relative;
}

.file-drop-zone:hover {
  border-color: #adb5bd;
}

.file-input-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
}

.account-details {
  background-color: #f8f9fa;
  border-radius: 0.375rem;
  padding: 1rem;
}
</style>